import { Svg } from 'client/widget-components/basicComponents';
import React from 'react';

interface TrashIconProps extends React.ComponentProps<typeof Svg> {
    size?: number;
}

const TrashIcon = ({ size = 20, ...restProps }: TrashIconProps) => {
    return (
        <Svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M15.6248 5.125L15.16 12.6438C15.0412 14.5648 14.9819 15.5254 14.5004 16.216C14.2622 16.5574 13.9558 16.8455 13.6003 17.062C12.8813 17.5 11.919 17.5 9.99428 17.5C8.0671 17.5 7.10348 17.5 6.38404 17.0612C6.02836 16.8443 5.72176 16.5556 5.48377 16.2136C5.00242 15.522 4.94434 14.5601 4.82821 12.6364L4.37476 5.125"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M3.25024 5.12501H16.7502M13.042 5.12501L12.5301 4.0688C12.1899 3.3672 12.0198 3.01639 11.7265 2.79761C11.6615 2.74908 11.5926 2.70591 11.5205 2.66853C11.1957 2.5 10.8058 2.5 10.0261 2.5C9.22685 2.5 8.82724 2.5 8.497 2.67559C8.42382 2.71451 8.35398 2.75943 8.28821 2.80988C7.99147 3.03753 7.82572 3.40116 7.4942 4.12845L7.03993 5.12501"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M8.12476 13.375V8.875"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11.8748 13.375V8.875"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </Svg>
    );
};

export default TrashIcon;

